<!--div class="px-3 page-overlay-wrapper" *ngIf="showSpinner">
  <div class="text-center text-primary progress-card">
    <div
      class="card shadow-sm p-3 mb-3 border border-tertiary flex-row"
      style="width: 350px; height: 60px"
    >
      <div class="text-left text-dark" style="width: 100%">
        <div id="loadingProgressG">
          <div id="loadingProgressG_1" class="loadingProgressG"></div>
        </div-->
<!-- <div class="progress" style="height: 40%;" aria-busy="true">
                    <div class="progress-bar" role="progressbar" style="width: %;" aria-valuenow="value" aria-valuemin="0" aria-valuemax="100" aria-valuetext="Please wait until the operation is finished.">
                    </div>
                </div> -->
<!--div class="text-left text-dark p-1">
          <strong>Loading... </strong>
        </div>
      </div>
    </div>
  </div>
</div-->

<div class="px-3" *ngIf="showSpinner">
  <div class="text-center text-primary">
    <div class="spinner-border"></div>
    <div class="h3 text-primary mt-3">Loading...</div>
  </div>
</div>
